import { z } from 'zod'

export const PaymentInterval = z.enum([
  'monthly',
  'quarterly',
  'half-annually',
  'annually',
  'free'
])

export type PaymentInterval = z.infer<typeof PaymentInterval>
